<template>
	<v-dialog
		v-model="visible_local" 
		persistent
		:retain-focus="false"
		:fullscreen="is_fullscreen"
	>
		<v-alert class="mx-3 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<v-progress-linear v-if="loading" class="px-3 mt-3" indeterminate color="rgba(0, 0, 0, 0.12)" height="12"></v-progress-linear>
		<EditItem
			v-if="item_item"
			:item="item_item"
			:color="'#81CC00'"
			@close="onClose()"
		/>
	</v-dialog>
</template>

<script>
import EditItem from "@/views/items/new_item.vue";
const Event_Item = 'item';

export default {
	name: 'EditItemDialog',
	data() {
		return {
			visible_local: true,
			is_fullscreen: true,

			loading: false,
			error_msg: '',

			item_id: 0,
			item_item: null
		}
	},
	components: {
		EditItem
	},
	created() {
		this.item_id = Number(this.$route.params.evid);
		this.getItem(this.item_id);
	},
	methods: {
		async getItem(id) {
			this.loading = true;

			const url = `/api/items/${id}`;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.loading = false;
						data['type'] = Event_Item;
						this.item_item = data;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onClose() {
			window.open("/close")
		}
	}
}
</script>


